(function () {
  document.querySelectorAll('[data-bdc-routine-timeline]').forEach(function (timeline) {
    var section = timeline.closest('.bdc-routine');
    if (!section) return;

    var stops = Array.prototype.slice.call(timeline.querySelectorAll('[data-bdc-routine-stop]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-bdc-routine-panel]'));

    stops.forEach(function (stop) {
      stop.addEventListener('click', function () {
        var targetId = stop.getAttribute('data-target');

        stops.forEach(function (s) { s.classList.remove('is-active'); });
        stop.classList.add('is-active');

        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.id === targetId);
        });
      });
    });
  });
})();